<template>
  <WidgetCard title="Today's alerts" icon="bell" :loading="loading" :error="error">
    <!-- AI-Triage: total in header + severity boxes. Otherwise: total as hero. -->
    <template v-if="aiTriage && !loading && !error && data" #headerExtra>
      <div class="dw-headstat">
        <div class="dw-headstat__top">
          <span
            v-if="data.deltaPct !== null"
            class="dw-delta"
            :class="deltaUp ? 'dw-delta--up' : 'dw-delta--down'"
            title="vs yesterday"
          >
            <a-icon :type="deltaUp ? 'arrow-up' : 'arrow-down'" />
            {{ Math.abs(data.deltaPct) }}%
          </span>
          <span class="dw-headstat__n">{{ data.total.toLocaleString() }}</span>
        </div>
      </div>
    </template>
    <template v-if="!loading && !error && data">
      <template v-if="aiTriage">
        <div class="dw-sevcards">
          <div
            v-for="chip in chips"
            :key="chip.level"
            class="dw-sevcard"
            :class="`dw-sevcard--${chip.level}`"
          >
            <div class="dw-sevcard__n">
              {{ chip.value === null ? '—' : chip.value }}
            </div>
            <div class="dw-sevcard__t">
              {{ chip.label }}
            </div>
          </div>
        </div>
        <div v-if="severityError" class="dw-note">
          Severity breakdown unavailable
        </div>
        <div v-else-if="severity && !severity.hasSeverity" class="dw-note">
          No alerts classified by AiTriage
        </div>
      </template>
      <div v-else class="dw-hero">
        <div class="dw-hero__n">{{ data.total.toLocaleString() }}</div>
        <div class="dw-hero__t">alerts today</div>
        <span
          v-if="data.deltaPct !== null"
          class="dw-delta dw-hero__delta"
          :class="deltaUp ? 'dw-delta--up' : 'dw-delta--down'"
          title="vs yesterday"
        >
          <a-icon :type="deltaUp ? 'arrow-up' : 'arrow-down'" />
          {{ Math.abs(data.deltaPct) }}% vs yesterday
        </span>
      </div>
    </template>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';

  export default {
    name: 'TodaysAlertsWidget',
    components: { WidgetCard },
    props: {
      data: { type: Object, default: null },
      severity: { type: Object, default: null },
      // Tracked separately: the severity call can fail while the day count succeeds.
      severityError: { type: [Boolean, String], default: false },
      aiTriage: { type: Boolean, default: false },
      loading: { type: Boolean, default: false },
      error: { type: [Boolean, String], default: false }
    },
    computed: {
      deltaUp() {
        return this.data && this.data.deltaPct !== null && this.data.deltaPct >= 0;
      },
      chips() {
        const s = this.severity;
        const has = s && s.hasSeverity;
        return [
          { level: 'high', label: 'HIGH', value: has ? s.high : null },
          { level: 'medium', label: 'MEDIUM', value: has ? s.medium : null },
          { level: 'low', label: 'LOW', value: has ? s.low : null }
        ];
      }
    }
  };
</script>
